import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MiddlearticlesInterface } from 'src/_lib/interfaces/performance-section.interface';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-subscribe-ch2',
  templateUrl: './subscribe-ch2.component.html',
  styleUrls: ['./subscribe-ch2.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NgIf,NgClass],
  encapsulation: ViewEncapsulation.None
})
export class SubscribeCh2Component {
  cdnImagePath = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
   chTheme11 = environment.chTheme11;
  @Input() index9:any;
  @Input() emaildata: MiddlearticlesInterface[] = [];
  @Output() onSubmit = new EventEmitter<any>();
  @Input() emailForm: FormGroup;
  @Input() errorMessage: string = '';
}